import React, { useState } from 'react';

import css from './FaqSection.module.css';
import { BrandIconCard } from '../../../../../components';

const faqList = [
  {
    question: 'The question appears here and expands...',
    answer: 'This section provides answers to frequently asked questions.',
  },
  {
    question: 'The question appears here and expands...',
    answer:
      'You can use this component by importing it and including it in your JSX.',
  },
  {
    question: 'The question appears here and expands...',
    answer: 'You can find more information in the documentation.',
  },
  {
    question: 'The question appears here and expands...',
    answer: 'You can find more information in the documentation.',
  },
  {
    question: 'The question appears here and expands...',
    answer: 'You can find more information in the documentation.',
  },
  {
    question: 'The question appears here and expands...',
    answer: 'You can find more information in the documentation.',
  },
  {
    question: 'The question appears here and expands...',
    answer: 'You can find more information in the documentation.',
  },
  {
    question: 'The question appears here and expands...',
    answer: 'You can find more information in the documentation.',
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = index => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className={css.faqContainer}>
      <div className={css.faqHeading}>Title For Section Here</div>
      <div className={css.faqGrid}>
        {faqList.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className={css.faqCard}>
              <div className={css.faqTitle} onClick={() => handleToggle(i)}>
                {item.question}
                <span>
                  <BrandIconCard type={isOpen ? 'minus' : 'plus'} />
                </span>
              </div>
              {isOpen && (
                <div className={css.faqDescription}>{item.answer}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FaqSection;
